import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginGuard} from './login-guard';

/* Componentes Principais */
import {LoginComponent} from './login/login.component';
// import { HomeComponent } from './home/home';
import {CatalogoComponent} from './catalogo/catalogo.component';
import {UsuarioComponent} from './usuario/usuario.component';
import {UsuarioNovoComponent} from './usuario/usuario-novo/usuario-novo.component';
import {ArquivoSiaComponent} from './arquivo-sia/arquivo-sia.component';
import {FluxoClienteInternoComponent} from './fluxo-cliente-interno/fluxo-cliente-interno';
import {FluxoClienteInternoCompletoComponent} from './fluxo-cliente-interno-completo/fluxo-cliente-interno-completo';
import {FluxoClienteExternoComponent} from './fluxo-cliente-externo/fluxo-cliente-externo';
import {ConsultaFluxosComponent} from './consulta-fluxos/consulta-fluxos';
import {PesquisaFluxoComponent} from './pesquisa-fluxo/pesquisa-fluxo.component';

/* Componentes Janela Modal */
import {ClienteModalComponent} from './modal/cliente-modal/cliente-modal.component';
import {InstalacaoProdutoModalComponent} from './modal/instalacao-produto-modal/instalacao-produto-modal.component';
import {HostnameModalComponent} from './modal/hostname-modal/hostname-modal.component';
import {MapaLayoutModalComponent} from './modal/mapa-layout-modal/mapa-layout-modal.component';
import {ServicoModalComponent} from './modal/servico-modal/servico-modal.component';
import {DetalheFtaModalComponent} from './modal/detalhe-fta-modal/detalhe-fta-modal.component';
import {ResumoFtaModalComponent} from './modal/resumo-novo-fta-modal/resumo-fta-modal.component';

/* Artefatos */
import {HomeArtefatoComponent} from './artefato/home-artefato/home-artefato.component';
import {ArtefatoInstalacaoProdutoComponent} from './artefato/instalacao-produto/instalacao-produto.component';
import {ArtefatoLayoutArquivoComponent} from './artefato/layout-arquivo/layout-arquivo.component';
import {ArtefatoOperacaoComponent} from './artefato/operacao/operacao.component';
import {ArtefatoServicoComponent} from './artefato/servico/servico.component';
import {CadastroServicoComponent} from './artefato/cadastro-servico/cadastro-servico.component';
import {
    CadastroInstalacaoProdutoComponent
} from './artefato/cadastro-instalacao-produto/cadastro-instalacao-produto.component';
import {CadastroLayoutArquivoComponent} from './artefato/cadastro-layout-arquivo/cadastro-layout-arquivo.component';
import {CadastroOperacaoComponent} from './artefato/cadastro-operacao/cadastro-operacao.component';
import {ProdutoTransmissaoComponent} from './artefato/produto-transmissao/produto-transmissao.component';
import {
    CadastroProdutoTransmissaoComponent
} from './artefato/cadastro-produto-transmissao/cadastro-produto-transmissao.component';
import {ParametroEntradaModalComponent} from './modal/parametro-entrada-moldal/parametro-entrada-modal.component';
import {RoteiroModalComponent} from './modal/roteiro-modal/roteiro-modal.component';
import {MigracaoFtaModalComponent} from './modal/migracao-fta-modal/migracao-fta-modal.component';
import {EdicaoArtefatosModalComponent} from './modal/edicao-artefatos/edicao-artefatos-modal.component';
import {ConfirmarFtaModalComponent} from './modal/confirmar-fta-modal/confirmar-fta-modal.component';
import {AjudaVariaveisComponent} from './modal/ajuda-variaveis-modal/ajuda-variaveis-modal.component';
import { AvaliacaoModalComponent } from './modal/avaliacao-modal/avaliacao-modal.component';

const routes: Routes = [
    {path: '', redirectTo: '/login', pathMatch: 'full'},

    /* Componentes Principais */
    {path: 'login', component: LoginComponent},
    {path: 'login/:refresh-token', component: LoginComponent},
    // { path: 'home', component: HomeComponent/* , canActivate: [LoginGuard] */ },
    {path: 'catalogo', component: CatalogoComponent},
    {path: 'usuario', component: UsuarioComponent},
    {path: 'usuario-novo', component: UsuarioNovoComponent},
    {path: 'usuario-novo/:codigo/:versao', component: UsuarioNovoComponent},
    {path: 'arquivo-sia', component: ArquivoSiaComponent},
    {path: 'fluxo-cliente-interno', component: FluxoClienteInternoComponent},
    {path: 'fluxo-cliente-interno-completo', component: FluxoClienteInternoCompletoComponent},
    {path: 'fluxo-cliente-interno-completo/:codigo/:versao', component: FluxoClienteInternoCompletoComponent},
    {path: 'fluxo-cliente-interno-completo/:codigo/:versao/:copia', component: FluxoClienteInternoCompletoComponent},
    {path: 'fluxo-cliente-interno-completo/:reload', component: FluxoClienteInternoCompletoComponent},

    {path: 'fluxo-cliente-externo', component: FluxoClienteExternoComponent},
    {path: 'consulta-fluxos', component: ConsultaFluxosComponent},
    {path: 'pesquisa-fluxo', component: PesquisaFluxoComponent},

    /* Componentes Janela Modal */
    {path: 'cliente-modal', component: ClienteModalComponent, outlet: 'modal'},
    {path: 'ajuda-variaveis-modal', component: AjudaVariaveisComponent, outlet: 'modal'},
    {path: 'edicao-artefatos-modal', component: EdicaoArtefatosModalComponent, outlet: 'modal'},
    {path: 'instalacao-produto-modal', component: InstalacaoProdutoModalComponent, outlet: 'modal'},
    {path: 'hostname-modal', component: HostnameModalComponent, outlet: 'modal'},
    {path: 'mapa-layout-modal', component: MapaLayoutModalComponent, outlet: 'modal'},
    {path: 'servico-modal', component: ServicoModalComponent, outlet: 'modal'},
    {path: 'detalhe-fta-modal', component: DetalheFtaModalComponent, outlet: 'modal'},
    {path: 'confirmar-fta-modal', component: ConfirmarFtaModalComponent, outlet: 'modal'},
    {path: 'resumo-fta-modal', component: ResumoFtaModalComponent, outlet: 'modal'},
    {path: 'roteiro-fta-modal', component: RoteiroModalComponent, outlet: 'modal'},
    {path: 'parametro-entrada-modal', component: ParametroEntradaModalComponent, outlet: 'modal'},
    {path: 'migracao-fta-modal', component: MigracaoFtaModalComponent, outlet: 'modal'},
    {path: 'avaliacao-modal', component: AvaliacaoModalComponent, outlet: 'modal'},


    /* Artefatos */
    {path: 'artefato-home', component: HomeArtefatoComponent},

    {path: 'artefato-instalacao-produto', component: ArtefatoInstalacaoProdutoComponent},
    {path: 'artefato-cadastro-instalacao-produto', component: CadastroInstalacaoProdutoComponent},
    {path: 'artefato-cadastro-instalacao-produto/:codigo/:versao', component: CadastroInstalacaoProdutoComponent},

    {path: 'artefato-operacao', component: ArtefatoOperacaoComponent},
    {path: 'cadastro-operacao', component: CadastroOperacaoComponent},
    {path: 'cadastro-operacao/:codigo/:versao', component: CadastroOperacaoComponent},

    {path: 'artefato-servico', component: ArtefatoServicoComponent},
    {path: 'cadastro-servico', component: CadastroServicoComponent},
    {path: 'cadastro-servico/:codigo/:versao', component: CadastroServicoComponent},

    {path: 'artefato-layout-arquivo', component: ArtefatoLayoutArquivoComponent},

    {path: 'artefato-cadastro-layout-arquivo', component: CadastroLayoutArquivoComponent},
    {path: 'artefato-cadastro-layout-arquivo/:codigo/:versao', component: CadastroLayoutArquivoComponent},

    {path: 'produto-transmissao-arquivo', component: ProdutoTransmissaoComponent},
    {path: 'detalha-produto-transmissao/:nome/:tipo', component: CadastroProdutoTransmissaoComponent},


];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule],
    providers: [LoginGuard]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts